/**
 * ResourcesSort functionality
 * @class
 */
export default class ResourcesSort {
    /**
     * @constructor
     * @param {HTMLElement} element The ResourcesSort root element
     */
    constructor(element) {
        var _a, _b, _c;
        this.el = element;
        this.components = {
            body: document.querySelector('body'),
            dropdown: this.el.querySelector('[data-sort-dropdown]'),
            input: this.el.querySelector('[data-sort-input]'),
            options: this.el.querySelectorAll('[data-sort-option]')
        };
        const searchParams = new URLSearchParams(window.location.search);
        const orderBySearchParams = searchParams.get("orderby");
        const pageSearchParams = searchParams.get("page");
        const searchTermSearchParams = searchParams.get("searchTerm");
        const resourceTypesSearchParams = searchParams.get("resourceTypes");
        const filterSearchParams = searchParams.get("filters");
        if (orderBySearchParams != null && this.components.input != null) {
            const activeOption = [...this.components.options].filter((option) => option.getAttribute('data-sort-option') === orderBySearchParams);
            this.components.input.value = (_a = activeOption[0].textContent) !== null && _a !== void 0 ? _a : "";
        }
        const toggleDropdown = (event) => {
            var _a;
            event.stopPropagation();
            (_a = this.components.dropdown) === null || _a === void 0 ? void 0 : _a.classList.toggle('sort__dropdown--opened');
        };
        const selectOption = (event) => {
            if (this.components.input != null) {
                const target = event.currentTarget;
                const sortOptionName = target.textContent;
                const sortOptionValue = target.getAttribute('data-sort-option');
                this.components.input.value = sortOptionName !== null && sortOptionName !== void 0 ? sortOptionName : 'A-Z';
                const urlBase = window.location.pathname;
                const page = pageSearchParams != null ? `page=${pageSearchParams}` : "";
                const searchTerm = searchTermSearchParams != null ? `&searchTerm=${searchTermSearchParams}` : "";
                const resourceTypes = resourceTypesSearchParams != null ? `&resourceTypes=${resourceTypesSearchParams}` : "";
                const filters = filterSearchParams != null ? `&filters=${filterSearchParams}` : "";
                const order = sortOptionValue === "Date" ? "date" : `${sortOptionValue === null || sortOptionValue === void 0 ? void 0 : sortOptionValue.toLowerCase()}`;
                const newUrl = `${urlBase}?${page}${searchTerm}${resourceTypes}${filters}&orderby=${order}`;
                window.location.replace(newUrl);
            }
        };
        const closeDropdownFromOutside = () => {
            var _a;
            if ((_a = this.components.dropdown) === null || _a === void 0 ? void 0 : _a.classList.contains('sort__dropdown--opened')) {
                this.components.dropdown.classList.remove('sort__dropdown--opened');
            }
        };
        (_b = this.components.body) === null || _b === void 0 ? void 0 : _b.addEventListener('click', closeDropdownFromOutside);
        this.components.options.forEach((option) => {
            option.addEventListener('click', selectOption);
        });
        (_c = this.components.dropdown) === null || _c === void 0 ? void 0 : _c.addEventListener('click', toggleDropdown);
        //console.log('ResourcesSort', this);
    }
    /**
     * Creates new instances of IResourcesSortUtils for each `[data-component="ResourcesSort"]` element
     */
    static init() {
        const ResourcesSortEl = document.querySelector('[data-component="ResourcesSort"]');
        if (ResourcesSortEl) {
            const ResourcesSortUtil = new ResourcesSort(ResourcesSortEl);
        }
    }
}
